import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the TextDataProtectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-text-data-protect',
  templateUrl: 'text-data-protect.html',
})
export class TextDataProtectPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TextDataProtectPage');
  }

}



// WEBPACK FOOTER //
// /src/pages/textPages/text-data-protect/text-data-protect.ts